/**
 * Header just after the Cox Bridge Bar
 * Renders the dealer logo and customer info
 */

import React, { useState } from 'react';
import { HeaderContainer, DealershipLogo, DealerName, FallbackLockup, StyledImage } from './DealershipHeader.style';
import type { DealershipHeaderProps } from '@makemydeal/dr-sales-checkin-types';

const DealershipHeader: React.FC<DealershipHeaderProps> = ({ config }) => {
    const { logoUrl, dealerName, onLogoClick } = config;
    const [failedLogoUrl, setFailedLogoUrl] = useState<string>();
    const showDealerName = !logoUrl || failedLogoUrl === logoUrl;

    return (
        <HeaderContainer>
            <DealershipLogo data-testid="logo-container" onClick={() => onLogoClick()}>
                {showDealerName ? (
                    <FallbackLockup data-testid="dealer-name-lockup">
                        <DealerName forwardedAs="span" size="base" weight="bold">
                            {dealerName}
                        </DealerName>
                    </FallbackLockup>
                ) : (
                    <StyledImage src={logoUrl} alt={dealerName} onError={() => setFailedLogoUrl(logoUrl)} />
                )}
            </DealershipLogo>
        </HeaderContainer>
    );
};

export default React.memo(DealershipHeader);
